import * as Sentry from "@sentry/remix";
import { replayIntegration } from "@sentry/browser";
/**
 * By default, Remix will handle hydrating your app on the client for you.
 * You are free to delete this file if you'd like to, but if you ever want it revealed again, you can run `npx remix reveal` ✨
 * For more information, see https://remix.run/file-conventions/entry.client
 */

import { RemixBrowser, useLocation, useMatches } from "@remix-run/react";
import { startTransition, StrictMode, useEffect } from "react";
import { hydrateRoot } from "react-dom/client";
import posthogJs from "posthog-js";

Sentry.init({
    dsn: "https://c31ef1711858a93ebf4b1ac5c6b9e31c@o4508338066751488.ingest.us.sentry.io/4508338071011328",
    tracesSampleRate: 1,

    integrations: [Sentry.browserTracingIntegration({
      useEffect,
      useLocation,
      useMatches
    }), replayIntegration({
        maskAllText: true,
        blockAllMedia: true
    })],

    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1
})

if (!document.querySelector('meta[name="viewport"]')) {
  const meta = document.createElement("meta");
  meta.name = "viewport";
  meta.content = "width=device-width,initial-scale=1";
  document.head.appendChild(meta);
}

function PosthogInit() {
  useEffect(() => {
    posthogJs.init("phc_oFZ1My8pbdb9DCktYr3OJIPaHtDkKmDmEXLFr7XUWNm", {
      api_host: "https://us.i.posthog.com",
      person_profiles: "always", // 'always' to create profiles for anonymous users, "identified_only" to create profiles for identified users only
    });
  }, []);

  return null;
}

startTransition(() => {
  hydrateRoot(
    document,
    <StrictMode>
      <RemixBrowser />
      <PosthogInit />
    </StrictMode>
  );
});
